import { Box, Flex } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type React from 'react';
import { useMemo } from 'react';
import styled, { keyframes } from 'styled-components';
import { CUSTOMERS_REVIEWS_DEFAULTS } from '../defaults';
import type { Tweet } from './TweetCard';
import { TweetCard } from './TweetCard';

const TWEET_WIDTH = 408;

const ContentWrapper = styled(Flex)`
  max-width: 100%;
`;

const SliderContainer = styled(Box)<{ readonly shortCard: boolean }>`
  width: 100%;

  .tweet-card {
    min-height: ${({ shortCard }) => (shortCard ? '0' : '31rem')};
  }
`;

const marqueeAnimation = keyframes`
    0% {
        transform: translateX(0%);
    }
    100% {
        transform: translateX(-100%);
    }
`;

const ReviewsMarqueeContainer = styled(Flex)<{
  readonly tweetCount: number;
  readonly shortCard: boolean;
}>`
  width: ${({ tweetCount }: { readonly tweetCount: number }) => `${tweetCount * TWEET_WIDTH}px`};
  align-self: start;
  height: auto
  position: relative;
  animation: ${marqueeAnimation} 35000ms linear infinite;

  ${MEDIA_QUERIES.desktop`
        &:hover {
            animation-play-state: paused;
        }
    `}

  ${MEDIA_QUERIES.mobile`
        animation-duration: 78000ms;
    `}
`;

export interface TweetsProps {
  readonly shortCard?: boolean;
  readonly tweets?: Tweet[];
}

export const Tweets: React.FC<TweetsProps> = ({
  shortCard = true,
  tweets = CUSTOMERS_REVIEWS_DEFAULTS.tweets as Tweet[],
}) => {
  const tweetList = useMemo(
    () =>
      tweets
        .map(tweet => ({ ...tweet, key: tweet.name }))
        .concat(tweets.map(tweet => ({ ...tweet, key: `${tweet.name} - cloned` }))),
    [tweets],
  );
  return (
    <ContentWrapper alignItems="center" flexWrap="wrap" justifyContent="center" mt={['30px', '45px']}>
      <SliderContainer shortCard={shortCard}>
        <ReviewsMarqueeContainer shortCard={shortCard} tweetCount={tweets.length}>
          {tweetList.map(tweet => {
            return (
              <div key={tweet.key}>
                <TweetCard shortCard={shortCard} tweet={tweet} />
              </div>
            );
          })}
        </ReviewsMarqueeContainer>
      </SliderContainer>
    </ContentWrapper>
  );
};
